import { render, staticRenderFns } from "./SettingsSmsConfig.vue?vue&type=template&id=839a3192"
import script from "./SettingsSmsConfig.vue?vue&type=script&lang=js"
export * from "./SettingsSmsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports